// SCROLL STATE (v20210213)
jQuery( function(){
	var t = jQuery('body');
	var cNT = 'is_noTop';
	var cBF = 'is_btf';
	var play = 40; // px

	jQuery(window).on('load scroll resize', function(){
		var st = jQuery(this).scrollTop();
		var wh = jQuery(this).height();

		if( st > play ) {
			t.addClass(cNT);
		}else{
			t.removeClass(cNT);
		}

		if( st > wh) {
			t.addClass(cBF);
		}else{
			t.removeClass(cBF);
		}
	});
});

// IN VIEW (v20201017)
// TOPへボタンをフッターに留めておく処理
jQuery( function(){
	var tgt = '.js_inView';
	var rdy = 'is_ready'
	var cls = 'is_inView';

	// Init
	var e = document.querySelectorAll(tgt);
	Array.prototype.slice.call(e,0).forEach(function(i){
		i.classList.add(rdy);
	});

	jQuery(window).on('load scroll resize', function(){
		var scroll = document.documentElement.scrollTop || document.body.scrollTop;
		var h =  window.innerHeight;
		var e = document.querySelectorAll(tgt);
		Array.prototype.slice.call(e,0).forEach(function(i){
			var pos = i.getBoundingClientRect().top + window.pageYOffset;
			if (scroll > pos - h) {
				i.classList.add(cls);
			}else{
				i.classList.remove(cls);
			}

			var dom1 = document.querySelector('footer');
			if( dom1.getBoundingClientRect().top < 700 )
			{
				jQuery( '.bl_side_btns' ).addClass( 'is_inView' );
			}
			else
			{
				jQuery( '.bl_side_btns' ).removeClass( 'is_inView' );
			}
		});
	});
});
jQuery( function(){
	if( jQuery( ".p-categories .p-categories__list li a" ).length )
	{
		jQuery( ".p-categories .p-categories__list li a" ).click( function(){
			if( jQuery( this ).closest( 'aside' ).hasClass( 'is-open' ) )
			{
				jQuery( this ).closest( 'aside' ).removeClass( 'is-open' );

				document.body.classList.remove( 'is-fixed' );
			}
		} );
	}
} );
jQuery( function(){
	if( jQuery( "select[name='lang']" ).length )
	{
		jQuery( "select[name='lang']" ).change( function(){
			if( jQuery( this ).val() == 'ja' )
			{
				if( location.href.startsWith( location.origin + '/en' ) )
				{
					var reg = new RegExp( '^' + location.origin + '/en' );

					location.href = location.href.replace( reg, location.origin );
				}
			}
			else
			{
				if( location.href.startsWith( location.origin + '/en' ) == false )
				{
					var reg = new RegExp( '^' + location.origin );

					location.href = location.href.replace( reg, location.origin + '/en' );
				}
			}
		} );
	}
} );
// バリエーション選択時に対応画像へSwiperをスライド
(function () {
  function initVariantImageSwitch() {
    var select = document.querySelector('.bl_variant_select select[name="id"]');
    if (!select || !window.variantImages) return;

    var swiperEl = document.querySelector('.p-slideshow--original');
    if (!swiperEl || !swiperEl.swiper) return;

    select.addEventListener('change', function () {
      var variantId = this.value;
      var slideIndex = window.variantImages[variantId];
      if (slideIndex !== undefined) {
        swiperEl.swiper.slideTo(slideIndex);
      }
    });
  }

  // Swiperの初期化を待ってから実行
  var attempts = 0;
  var timer = setInterval(function () {
    attempts++;
    var swiperEl = document.querySelector('.p-slideshow--original');
    if (swiperEl && swiperEl.swiper) {
      clearInterval(timer);
      initVariantImageSwitch();
    }
    if (attempts > 20) clearInterval(timer); // 最大2秒待つ
  }, 100);
})();
